/*global GridController,GridFormAndImporterController, FormController, WebView, Mustache, ViewController*/

function genGridHtml(screen, viewName){
    var schema = WebView.fieldsSchema.getSchema();

    var html = '<table data-idfield="">';
    html += "<thead>";
    if(screen.searches.length>0){
        html += "<tr data-criterias>";
        screen.searches.forEach(function(s){
            var type = "single" ;
            schema[viewName].columns.some(function(col){
                if(col.name === s.code){
                    if(col.type.indexOf("date") === 0 || col.type === "timestamp"){
                        type = "between" ;
                    }else if(col.type.indexOf("int") === 0 || col.type.indexOf("float") === 0){
                        type = "between" ;
                    }
                    return true ;
                }
            }) ;
            html += '<td data-field-name="'+s.code+'" data-field-label="'+s.name+'" data-type="'+type+'"></td>';
        }) ;
        html += "</tr>";
    }
    screen.columns.forEach(function(c){
        var visible = "" ;
        if(c.hidden){
            visible = ' data-visible="false"' ;
        }
        var totals = "" ;
        if(c.total_ope){
            totals = ' data-totals="'+c.total_ope+'"' ;
        }

        
        let colName = c.code;
        let colDef = schema[viewName].columns.find(col=>col.name === c.code || col.name === "x_ct_"+c.code) ;
        if(colDef){
            colName = colDef.name;
        }
        html += '<th data-field-name="'+colName+'" '+visible+totals+'><label>'+c.name+'</label></th>';
    }) ;
    html += "</thead>";
    html += "</table>";

    return html;
}

function getTableName(screen){
    let tableName ;
    if(screen.type_table === "query" && screen.query ){
        tableName = "x_v_"+screen.query.code.toLowerCase().replace(/[^a-z0-9_]/g, "_")  ;
    }else if(screen.model){
        tableName = screen.model.model.replace(/\./g, "_");
    }
    return tableName;
}

function getRoute(screen, route){
    if(screen.public_screen){
        return "custom-public-"+route;
    }
    return route;
}

var CustomScreenGridController = function(screen){

    let tableName  = getTableName(screen) ;

    var viewName = tableName;

    GridController.call(this, viewName, {
        title: screen.name, 
        html: genGridHtml(screen, viewName),
        serverSideMode: true,
        route: getRoute(screen,viewName.replace(/_/g, "-") )
    }) ;


    if(screen.open_url){
        this.onRowDblClick = function(ev){
            Mustache.parse(screen.open_url);
            var url = Mustache.render(screen.open_url, ev.data); 
            window.location.href = url ;
        } ;
    }
} ;


CustomScreenGridController.prototype = Object.create(GridController.prototype);
CustomScreenGridController.prototype.constructor = CustomScreenGridController;



var CustomScreenGridAndFormController = function(screen){
    let tableName = getTableName(screen) ;

    GridFormAndImporterController.call(this, tableName, {
        grid: {
            title: screen.name, 
            html: genGridHtml(screen, tableName),
            serverSideMode: true,
            route: getRoute(screen,screen.code.replace(/_/g, "-") +"-grid")
        },
        form: {
            title: screen.name, 
            html: screen.html_view,
            route: getRoute(screen,screen.code.replace(/_/g, "-") +"-form")
        }
    }) ;


} ;


CustomScreenGridAndFormController.prototype = Object.create(GridFormAndImporterController.prototype);
CustomScreenGridAndFormController.prototype.constructor = CustomScreenGridAndFormController;


var CustomFormController = function(screen){
    let tableName = getTableName(screen) ;

    FormController.call(this, tableName, {
        title: screen.name, 
        html: screen.html_view,
        route: getRoute(screen,screen.code.replace(/_/g, "-") +"-form")
    }) ;
} ;


CustomFormController.prototype = Object.create(FormController.prototype);
CustomFormController.prototype.constructor = CustomFormController;



var CustomViewController = function(screen){
    let options = {
        html: screen.html_view,
        route: getRoute(screen,screen.code.toLowerCase().replace(/[^a-z0-9_]/g, "_") +"-view")
    } ;
    if(screen.public_screen){
        options.container = "main" ;
    }
    
    ViewController.call(this, options) ;
} ;


CustomViewController.prototype = Object.create(ViewController.prototype);
CustomViewController.prototype.constructor = CustomViewController;


function createCustomController(screen){
    if(screen.type === "grid"){
        return new CustomScreenGridController(screen) ;
    }else if(screen.type === "form"){
        return new CustomFormController(screen) ;
    }else if(screen.type === "gridAndForm"){
        return new CustomScreenGridAndFormController(screen) ;
    }else if(screen.type === "view"){
        return new CustomViewController(screen) ;
    }
}




module.exports.createCustomController = createCustomController ;
